import pluralize from 'pluralize';
import capitalize from 'lodash/capitalize';

import { Heading16 } from 'approot/shared/styles/typography.style';
import Text from 'approot/shared/styles/typography/text';

type Props = {
  questionTypes: string[];
};

const QuestionTypesView = ({ questionTypes }: Props) => {
  return (
    <>
      <Heading16 as="h3" marginBottom={0} marginTop={12}>
        {pluralize('Question Type', questionTypes.length)}
      </Heading16>
      <Text>
        {questionTypes
          .map(qt => capitalize(qt))
          .sort()
          .join(', ')}
      </Text>
    </>
  );
};

export default QuestionTypesView;
